<template>
  <EntityModal
    v-if="modalContexts"
    :contexts="modalContexts"
    :entity-context="entityContextName"
    :field-name="fieldName"
    :title="title"
    :max-width="maxWidth"
    :app-name="resolvedAppName"
  >
    <ContainerProduction v-bind="containerProps">
      <slot />
    </ContainerProduction>
  </EntityModal>
</template>

<script>
import EntityModal from "@bloglovin/inspire-engine/Components/EntityModal.vue";
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { hasCompletePk } from "%/dynamic-component-editor/helpers/complete-pk";
import { mergeEngineContexts, engineCurrentUserPk } from "%/dynamic-component-editor/helpers/engine-current-user";
import { Context } from "%/dynamic-component-editor/classes/context-v2";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ModalTitle from "%/dynamic-component-editor/options/modal-title";
import MaxWidth from "%/dynamic-component-editor/options/max-width";

export default {
  name: "EntityModalContainer",
  components: { EntityModal, ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  inheritAttrs: false,
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    entityContextName() {
      return this.elementContext?.entityContext ?? "";
    },
    fieldName() {
      return this.elementContext?.field ?? "";
    },
    modalContexts() {
      if (!this.contextItem || !this.entityType || !this.entityContextName || !hasCompletePk(this.contextItem.entityPkUrlVars)) {
        return null;
      }
      return mergeEngineContexts(Context.contexts, this.scopedProvidedContexts?.(), {
        [this.entityContextName]: {
          entityType: this.entityType,
          pk: this.contextItem.entityPkUrlVars,
          appName: this.resolvedAppName,
        },
      }, { currentUserPk: engineCurrentUserPk() });
    },
    title() {
      return this.getOptionValue(ModalTitle) || "";
    },
    maxWidth() {
      const width = Number.parseInt(this.getOptionValue(MaxWidth), 10);
      return Number.isFinite(width) ? width : undefined;
    },
  },
};
</script>
